import React from 'react';
import './ContactUsModal.css';

const ContactUsModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="contact-modal-overlay" onClick={onClose}>
      <div className="contact-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="contact-modal-header">
          <div className="contact-header-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2>Contact Us</h2>
          <p className="contact-subtitle">Get in Touch with Resumeglobe</p>
          <button className="contact-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="contact-modal-body">
          <div className="contact-intro-section">
            <p>We're always here to support you and ensure your experience with Resumeglobe is smooth and seamless. Whether you have a question, need assistance, want to share feedback, or explore partnership opportunities, we're ready to help.</p>
            <p>Our team is committed to responding promptly and providing the guidance you need.</p>
          </div>

          {/* Customer Support Section */}
          <div className="contact-section">
            <div className="contact-section-header">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M13.73 21a2 2 0 01-3.46 0" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <h3>Customer Support</h3>
            </div>
            <p>For all support-related queries, including account issues, payments, subscription questions, or technical assistance, reach out to us at:</p>
            <a href="mailto:support@resumeglobe.com" className="contact-email-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              support@resumeglobe.com
            </a>
            <p className="contact-note">Please provide clear details of your issue so we can assist you efficiently. Our team typically responds within 24–48 hours.</p>
          </div>

          {/* Business & Partnerships Section */}
          <div className="contact-section">
            <div className="contact-section-header">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <h3>Business & Partnerships</h3>
            </div>
            <p>If you're interested in collaborations, affiliate programs, university tie-ups, or corporate partnerships, contact our business team at:</p>
            <a href="mailto:support@resumeglobe.com" className="contact-email-link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              support@resumeglobe.com
            </a>
            <p className="contact-note">We welcome new opportunities and will get back to you promptly to explore how we can work together.</p>
          </div>

          {/* Support Hours Section */}
          <div className="contact-section highlight-section">
            <div className="contact-section-header">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
              <h3>Support Hours</h3>
            </div>
            <div className="support-hours-box">
              <p><strong>Monday – Friday</strong></p>
              <p className="hours-time">10:00 AM – 6:00 PM (IST)</p>
              <p className="hours-note">Note: Public holidays are excluded from support hours. Responses may be delayed on these days.</p>
            </div>
          </div>

          {/* Location Section */}
          <div className="contact-section">
            <div className="contact-section-header">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              <h3>Location</h3>
            </div>
            <div className="location-box">
              <p className="location-country">India 🇮🇳</p>
              <p>While we primarily provide online support, we're always ready to assist you wherever you are.</p>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn-close-modal" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ContactUsModal;
